module.exports = __webpack_public_path__ + "static/Chwinga-3-3eff1173d150d0735f937b62beb38e83.webp";